export function hasSmartPricingSearchParam() {
  const params = new URLSearchParams(document.location.search);
  const hasSmartPricing = params.get("smartPricing") === "true";

  return hasSmartPricing;
}
